import { Component, Input, OnInit } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { PAGE_FIX_EVENT } from '@client/app/modules/page-fix/constants/page-fix-event';

@Component({
    selector: 'page-fix-form-wizard-container-footer-options',
    templateUrl: './options.component.html',
    standalone: false,
})
export class PageFixFormWizardContainerFooterOptionsComponent implements OnInit {
    @Input() formValid?: boolean | undefined;
    @Input() pageFixApplied?: boolean | undefined;
    @Input() saving!: boolean;
    @Input() removing!: boolean;
    @Input() warning!: string;

    constructor (private monEventService: MonEventService) {}

    ngOnInit (): void {
        this.saving = false;
        this.removing = false;
    }

    submit (): void {
        this.monEventService.run(PAGE_FIX_EVENT.REQUEST_PREPARE_PAYLOAD);
    }

    removeCheck (): void {
        this.monEventService.run(PAGE_FIX_EVENT.REQUEST_DESTROY);
    }
}
